import { IconName } from "@zapier/zinnia-icons";
import { AssetTypes } from "./types";

const assetIcons: Partial<Record<AssetTypes, IconName>> = {
  agent: "navAgents",
  canvas: "navCanvas",
  chatbot: "navAIChatbot",
  connection: "zapierLogo",
  folder: "navFolder",
  interface: "navInterfaces",
  nextGenForm: "navInterfaces",
  table: "navTables",
  template: "navTemplate",
  zap: "miscBoltAltFill",
  tableView: "actionInsert",
  tableSubscription: "miscBoltAltFill",
};

export const getAssetIcon = (assetType: string | AssetTypes) => {
  return assetIcons[assetType as AssetTypes] || "zapierLogo";
};
